import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, Router, RouterStateSnapshot } from '@angular/router';
import { catchError, forkJoin, Observable, throwError } from 'rxjs';
import { MessagesService } from './layout/common/messages/messages.service';
import { NavigationService } from './core/navigation/navigation.service';
import { UserService } from './core/user/user.service';

@Injectable({
    providedIn: 'root'
})
export class InitialDataResolver implements Resolve<any>
{
    /**
     * Constructor
     */
    constructor(
        private _messagesService: MessagesService,
        private _navigationService: NavigationService,
        private router: Router,
        private _userService: UserService
    ) { }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Use this resolver to resolve initial mock-api for the application
     *
     * @param route
     * @param state
     */
    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
        // Fork join multiple API endpoint calls to wait all of them to finish
        return forkJoin([
            this._userService.get(),
            this._userService.getRole(),
            this._userService.getBrands(),
            this._messagesService.getFirst(),
            this._navigationService.get(),
        ]).pipe(
            catchError((error) => {
                this.router.navigate(['500']);
                return throwError(() => error);
            })
        );
    }
}
